interface response {
    code: number;
    message: string;
    data: {
        shareCode: string;
    }
  }
  
export function getShareCode (): Promise<response> {
  return request({
    url: '/gamecard/v2/share/assistance/getShareCode',
  });
}
  